/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`w/v is grams per 100 mL, w/w is grams per 100 g, and v/v is millilitres per 100 mL. This calculator computes w/v; the same part-over-whole arithmetic applies to w/w and v/v when the two amounts use the same unit.`)
};

const es_pctsol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p/v son gramos por 100 mL, p/p son gramos por 100 g, y v/v son mililitros por 100 mL. Esta calculadora calcula p/v; la misma aritmética de parte-sobre-total se aplica a p/p y v/v cuando las dos cantidades usan la misma unidad.`)
};

const de_pctsol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`w/v ist Gramm pro 100 mL, w/w ist Gramm pro 100 g, und v/v ist Milliliter pro 100 mL. Dieser Rechner berechnet w/v; dieselbe Teil-durch-Ganzes-Rechnung gilt für w/w und v/v, wenn beide Mengen dieselbe Einheit verwenden.`)
};

const nl_pctsol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`g/v is gram per 100 mL, g/g is gram per 100 g, en v/v is milliliter per 100 mL. Deze calculator berekent g/v; dezelfde deel-op-geheel rekenwijze geldt voor g/g en v/v wanneer beide hoeveelheden dezelfde eenheid gebruiken.`)
};

const fr_pctsol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le p/v est en grammes par 100 mL, le p/p en grammes par 100 g, et le v/v en millilitres par 100 mL. Ce calculateur calcule le p/v ; le même calcul partie/tout s'applique au p/p et au v/v lorsque les deux quantités utilisent la même unité.`)
};

const it_pctsol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p/v è grammi per 100 mL, p/p è grammi per 100 g, e v/v è millilitri per 100 mL. Questo calcolatore calcola p/v; la stessa aritmetica parte-su-tutto vale per p/p e v/v quando le due quantità usano la stessa unità.`)
};

const pt_br2_pctsol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p/v é gramas por 100 mL, p/p é gramas por 100 g, e v/v é mililitros por 100 mL. Esta calculadora computa p/v; a mesma aritmética de parte sobre o todo se aplica a p/p e v/v quando as duas quantidades usam a mesma unidade.`)
};

const pt_pctsol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m/v são gramas por 100 mL, m/m são gramas por 100 g, e v/v são mililitros por 100 mL. Esta calculadora determina m/v; a mesma aritmética de parte-sobre-todo aplica-se a m/m e v/v quando as duas quantidades usam a mesma unidade.`)
};

const ja_pctsol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`w/vは100 mLあたりのグラム数、w/wは100 gあたりのグラム数、v/vは100 mLあたりのミリリットル数です。この計算ツールはw/vを計算しますが、2つの量が同じ単位を使う場合、同じ「部分÷全体」の計算がw/wとv/vにも適用できます。`)
};

const zh_pctsol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`w/v 是每 100 mL 的克数，w/w 是每 100 g 的克数，v/v 是每 100 mL 的毫升数。本计算器计算的是 w/v；当两个量使用相同单位时，同样的“部分除以整体”算法也适用于 w/w 和 v/v。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_faq_a2", locale)
	if (locale === "en") return en_pctsol_faq_a2(inputs)
	if (locale === "es") return es_pctsol_faq_a2(inputs)
	if (locale === "de") return de_pctsol_faq_a2(inputs)
	if (locale === "nl") return nl_pctsol_faq_a2(inputs)
	if (locale === "fr") return fr_pctsol_faq_a2(inputs)
	if (locale === "it") return it_pctsol_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_faq_a2(inputs)
	if (locale === "pt") return pt_pctsol_faq_a2(inputs)
	if (locale === "ja") return ja_pctsol_faq_a2(inputs)
	return zh_pctsol_faq_a2(inputs)
};